import React from 'react';
import styleGlobal from '../../../../Global.module.css';
import { Card } from '@mui/material';
import Progress from '../../../Progress';

function ContainerCard({ loading = false, children }) {
  return (
    <header className={styleGlobal.headerGlobal}>
      {loading ? <Progress /> : null}
      <Card style={{ padding: '2rem', borderRadius: '20px' }}>
        {children}
      </Card>
    </header>
  );
}

export default ContainerCard;
